<div class="p-4 relative">

  <ami-table-actions
    [settings]="table.settings"
    [data]="table.data"
    [actions]="table.actions"
    [actionsHead]="table.actionsHead"
    (action)="onReciveAction($event)"
    [hidden]="error"
  ></ami-table-actions>

  <div *ngIf="loading"
       class="absolute top-0 left-0 right-0 bottom-0 flex justify-content-center align-items-center"
       style="background: rgba(255,255,255,0.7);">
    <p-progressSpinner></p-progressSpinner>
    <span class="ml-3">Cargando kardex...</span>
  </div>

  <ng-container *ngIf="error">
    <p class="text-red-500">Error al cargar el kardex</p>
  </ng-container>

</div>
